<template>
    <div class="showhide" :data-active="`${active}`">
        <button @click="toggle" class="r">
            <h2 class="showhide__title type--h3--default">
                <div class="showhide__title__indicator">
                    <span class="showhide__title__indicator__icon showhide__title__indicator__icon--active">
                        <Icon name="hide"/>
                    </span>
                    <span class="showhide__title__indicator__icon showhide__title__indicator__icon--inactive">
                        <Icon name="show"/>
                    </span>
                </div>
                <div class="showhide__title__text" v-text="shTitle"></div>
            </h2>
        </button>
        <div ref="container" class="showhide__content">
            <div ref="inner" class="showhide__content__inner type--content-links type--card-margins type--card-styles" v-html="shContent"></div>
        </div>
    </div>
</template>

<script>
    import Icon from "@c/Icon.vue";
    export default {
        components: {
            Icon,
        },
        data() {
            return {
                active: false,
            }
        },
        methods: {
            toggle() {
                if (this.active) {
                    this.hide();
                } else {
                    this.show();
                }
            },
            show() {
                this.active = true;
                // Get the height of the content of the container
                let height = this.$refs.inner.clientHeight + 'px';
                setTimeout(() => {
                    // Set the height of the container to the height of the inner content
                    this.$refs.container.style.height = height;
                }, 0);
            },
            hide() {
                // Set the height of the container back to 0
                this.$refs.container.style.height = '0px';
                this.active = false;
            },
        },
        props: {
            shTitle: String,
            shContent: String,
        },
    }
</script>

<style lang="scss">
@import "@s/_mixins.scss";
@import "@s/_vars.scss";
.showhide {
    padding: rem(12px) rem(14px) rem(12px) rem(12px);
    background-color: var(--color-sp-cream);
    border: 1px solid var(--color-sp-border);
    border-radius: rem(6px);
    &:hover, &:focus {
        border-color: var(--color-sp-border-dark);
    }
}
.showhide__title__indicator {
    position: absolute;
    left: 0;
}
.showhide__title__text {
    padding-left: rem(30px);
    display: block;
    text-align: left;
}
.showhide__content {
    padding-left: rem(30px);
    transition: height 0.35s ease-in-out;
    overflow: hidden;
    height: 0;

}
.showhide__content__inner {
    padding-top: rem(10px);
    padding-bottom: rem(10px);
}

.showhide {
    &[data-active="true"] {
        .showhide__title__indicator__icon {
            &--active {
                display: block;
            }
            &--inactive {
                display: none;
            }
        }
    }
    &[data-active="false"] {
        .showhide__title__indicator__icon {
            &--active {
                display: none;
            }
            &--inactive {
                display: block;
            }
        }
    }
}
</style>